import React, { useState, useEffect } from "react";
import { GetAdsInfoData, GetUsersData } from "../../../lib/data";
import AddAdsUi from "../../../ui/adsUi/AddAdsUi";
import i18n from "../../../lib/i18n";
import { ThreeDot } from "react-loading-indicators";
import { typeOfcurrencyAddAds } from "../../../lib/definitions";
import { useLocation } from "react-router-dom";

export default function AddAds() {
    const [adsInfoData, setAdsInfoData] = useState(null);
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(true);
    const t = i18n.t.bind(i18n);
    const location = useLocation();
    const passedName = location.state?.name;
    const passedId = location.state?.id;
    
    useEffect(() => {
        handleApi();
    }, []);

    const handleApi = async () => {
        setLoading(true);
        const infoData = await GetAdsInfoData();
        const usersData = await GetUsersData();
        setUserData(usersData.data);
        setAdsInfoData(infoData);
        setLoading(false);
    };

    const search = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const usersDataFilter = await GetUsersData(1,params);
            setUserData([]);
            usersDataFilter.data.map((e) => setUserData((prev) => [...prev, e]));
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-[25rem]">
                <ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" />
            </div>
        );
    }

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">
                    {t("add_page_title.ad", "Add Ad")}
                </h1>
                <AddAdsUi passedName={passedName} passedId={passedId} typeOfcurrency={typeOfcurrencyAddAds} userData={userData} adsInfoData={adsInfoData} search={search} />
            </div>
        </div>
    );
}
